







import {Component} from "vue-property-decorator"
import BaseVue from "../../utils/BaseVue"

@Component
export default class AuthPending extends BaseVue {
}
